import { render } from "./statisticsPage.vue?vue&type=template&id=3815ff0e&scoped=true"
import script from "./statisticsPage.vue?vue&type=script&lang=js"
export * from "./statisticsPage.vue?vue&type=script&lang=js"

import "./statisticsPage.vue?vue&type=style&index=0&id=3815ff0e&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3815ff0e"]])

export default __exports__